"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTheme = exports.defaultTheme = void 0;
const default_1 = __importDefault(require("./default"));
exports.defaultTheme = default_1.default;
const styles_1 = require("@mui/material/styles");
Object.defineProperty(exports, "createTheme", { enumerable: true, get: function () { return styles_1.createTheme; } });
